<div [ngClass]="{'w-100 partial-height-mobile': !viewportService.isLargeViewPort(), 'h-100 width-400px': viewportService.isLargeViewPort()}"
     class="position-absolute overflow-x-hidden background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row position-fixed background-light-gray border-bottom border-dark-subtle p-3 m-0 z-max d-flex align-items-center height-details-header">
        <div (click)="back()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-chevron-left color-secondary-information m-auto"></i>
        </div>
        <div class="col-2 m-0 d-flex justify-content-center">
            <app-bluetooth-svg [status]='status()'/>
        </div>
        @if (!loading) {
            <div class="col-8 m-0">
                <div class="fw-bold">{{ asset()?.name || '-' }}</div>
                <div class="{{ statusMessageColorClass() }}">{{ statusMessage() }}</div>
            </div>
        }
        <div (click)="close()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-x color-secondary-information m-auto"></i>
        </div>
    </div>
    <div class="d-flex flex-column gap-3 margin-top-details-header ps-3 pe-3 overflow-x-hidden overflow-y-auto fix-overflow-scroll no-scroll-bar">
        <div>
            <div class="fw-bold mb-2">Observed animals</div>
            <app-observed-animals
                [assignedAnimals]="assignedAnimals()"
                [animals]="currentlyVisibleAnimals()"
                [canClear]="true"
                [canRefresh]="true"
                [lastObservationPerAnimalId]="lastObservationPerAnimalId()"
                (onClear)="resetCurrentlyInRangeThreshold()"
                (onRefresh)="refresh()"
                name="Currently in range"/>
            <app-observed-animals
                [assignedAnimals]="assignedAnimals()"
                [animals]="animalsSeenInLastHour()"
                [lastObservationPerAnimalId]="lastObservationPerAnimalId()"
                name="Seen last hour"/>
            <app-observed-animals
                [assignedAnimals]="assignedAnimals()"
                [animals]="animalsSeenInLastTwentyFourHours()"
                [lastObservationPerAnimalId]="lastObservationPerAnimalId()"
                name="Seen last 24 hours"/>
            <app-observed-animals
                [assignedAnimals]="assignedAnimals()"
                [animals]="animalsSeenInLastFiveDays()"
                [lastObservationPerAnimalId]="lastObservationPerAnimalId()"
                name="Seen last 5 days"/>
            <app-observed-animals
                [assignedAnimals]="assignedAnimals()"
                [animals]="animalsSeenAtLeastFiveDaysAgo()"
                [lastObservationPerAnimalId]="lastObservationPerAnimalId()"
                name="Seen > 5 days ago"/>
        </div>
        <div>
            <div class="fw-bold mb-2">Assigned animals</div>
            <app-observed-animals
                [assignedAnimals]="assignedAnimals()"
                [animals]="animalsAssignedButNotSeenLastHour()"
                [lastObservationPerAnimalId]="lastObservationPerAnimalId()"
                name="Not seen last hour"
                [onlyAssigned]="true"/>
            <app-observed-animals
                [assignedAnimals]="assignedAnimals()"
                [animals]="animalsAssignedButNotSeenLastTwentyFourHours()"
                [lastObservationPerAnimalId]="lastObservationPerAnimalId()"
                name="Not seen last 24 hours"
                [onlyAssigned]="true"/>
            <app-observed-animals
                [assignedAnimals]="assignedAnimals()"
                [animals]="animalsAssignedButNeverSeen()"
                [lastObservationPerAnimalId]="lastObservationPerAnimalId()"
                name="Never seen"
                [onlyAssigned]="true"/>
        </div>
        @if (!hasSampleBasedLocation()) {
            <app-generic-button
                class="button"
                (click)="showLocation()"
                description="Show last reported GPS position"
                [alwaysShowText]="true"
                [disabled]="currentLocation() === undefined"
                [buttonText]="'Show last reported GPS position'"/>
        }
        <div>
            <div class="fw-bold mb-2">Scanning devices</div>
            @for (scannerId of associatedScannerIds(); track scannerId) {
                <app-scanner (click)="customizeDevice(scannerId)" [deviceId]="scannerId"/>
            }
        </div>
        <app-generic-button
            (click)="toggleCustomize('/main/customize-proximity-sample-point')"
            description="Customize proximity-sample point"
            [alwaysShowText]="true"
            [buttonText]="'Customize'"
            [disabled]="loading || !canBeAltered"
            [primaryIcon]="'fa-solid fa-gear'"></app-generic-button>
        <app-generic-button
            (click)="delete()"
            description="Delete proximity-sample point"
            [alwaysShowText]="true"
            [buttonClass]="'btn-danger btn-danger-shadow'"
            [buttonText]="'Delete'"
            [disabled]="loading || !canBeDeleted || deviceAssociations().length > 1"
            [primaryIcon]="'fa-solid fa-trash-can'"/>
      <app-asset-metadata [id]="asset()?.id" [relatedDeviceAssociations]="deviceAssociations()"/>
    </div>
</div>
